import { render } from "./Notes5.vue?vue&type=template&id=0e62460a&scoped=true"
import script from "./Notes5.vue?vue&type=script&lang=js"
export * from "./Notes5.vue?vue&type=script&lang=js"

import "./Notes5.vue?vue&type=style&index=0&id=0e62460a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e62460a"]])

export default __exports__